<template>
  <ZoneForm
    title="Add zone"
    :main-error="mainError"
    :inputs-errors="inputsErrors"
    @submit="submit"
  />
</template>

<script>
import ZoneForm from './zone-form';

export default {
  name: 'AddZone',
  components: { ZoneForm },
  props: ['projectCode'],
  data() {
    return {
      mainError: null,
      inputsErrors: []
    };
  },
  methods: {
    submit(data) {
      this.$store
        .dispatch('zones/create', {
          projectCode: this.projectCode,
          data
        })
        .then(
          () => {
            this.$router.push({
              name: 'zonesList',
              params: { reload: true }
            });
          },
          response => {
            if (response.status === 422) {
              this.inputsErrors = response.body.errors;
            } else {
              this.mainError = 'Something went wrong';
            }
          }
        );
    }
  }
};
</script>
